import { Tooltip } from "antd";
import {
  DateParts,
  durationReadable,
  formatTime,
  isDateParts,
  toDate,
} from "src/utils/date";

const DEFAULT_FORMAT = "MMM D, YYYY";

export const Time = (props: {
  value?: string | DateParts;
  format?: string;
  relative?: boolean;
  style?: React.CSSProperties;
  className?: string;
}) => {
  if (!props.value || props.value == "__VZBL::null__") return <>N/A</>;
  const date = isDateParts(props.value)
    ? toDate(props.value)
    : new Date(props.value);
  // if date is within 24 hours, show relative time
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const diffHours = diff / (1000 * 60 * 60);
  const format = props.format || DEFAULT_FORMAT;
  const relative = props.relative === undefined ? true : props.relative;
  if (relative && diffHours < 24) {
    return (
      <Tooltip title={formatTime(date.toISOString(), false)}>
        <span style={props.style} className={props.className}>
          {formatTime(date.toISOString(), true)}
        </span>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={formatTime(date.toISOString(), false)}>
      <span style={props.style} className={props.className}>
        {formatTime(date.toISOString(), format)}
      </span>
    </Tooltip>
  );
};

export const TimeDuration = (props: {
  value?: number;
  startDate?: any;
  endDate?: any;
}) => {
  if (props.value) {
    return (
      <Tooltip title={props.value}>{durationReadable(props.value)}</Tooltip>
    );
  }
  if (props.startDate && props.endDate) {
    const start = new Date(props.startDate);
    const end = new Date(props.endDate);
    const diff = end.getTime() - start.getTime();
    return <Tooltip title={diff}>{durationReadable(diff)}</Tooltip>;
  }
  return <>N/A</>;
};
